package uz.ferro.erp.feature.customer.data

import uz.ferro.erp.api.suspendGet
import uz.ferro.erp.feature.visit.model.VisitDto

object VisitRepository {
    suspend fun getVisits(dateFormatted: String): List<VisitDto> {
        return suspendGet("visit/list", queryParams = mapOf("date" to dateFormatted))
    }
}